import { Arrays } from "ext/array";
import { ID } from "store/id";
import appStore from "store/store";
export class GroupObjects {
    /** Creates a group from given child IDs. The group's ID can be optionally specified. */
    constructor(ids, groupId) {
        this.newGroup = {
            id: groupId !== null && groupId !== void 0 ? groupId : ID.mint("group"),
            items: ids,
        };
    }
    execute() {
        /** Pass a shallow copy, not a reference. */
        appStore.dispatchFn("Group", store => createGroup(store, Object.assign({}, this.newGroup)));
    }
    undo() {
        appStore.dispatchFn("Ungroup", store => ungroup(store, this.newGroup));
    }
}
export class BreakGroup {
    constructor(group) {
        this.group = group;
    }
    execute() {
        appStore.dispatchFn("Ungroup", store => ungroup(store, this.group));
    }
    undo() {
        appStore.dispatchFn("Group", store => createGroup(store, this.group));
    }
}
function createGroup(store, parent) {
    let childIds = parent.items;
    let newStore = Object.assign(Object.assign({}, store), { arrows: store.arrows.map(a => Arrays.includes(childIds, a.id) ? Object.assign(Object.assign({}, a), { parentGroup: parent.id }) : a), items: store.items.map(i => Arrays.includes(childIds, i.id) ? Object.assign(Object.assign({}, i), { parentGroup: parent.id }) : i), groups: store.groups.map(g => Arrays.includes(childIds, g.id) ? Object.assign(Object.assign({}, g), { parentGroup: parent.id }) : g) });
    newStore.groups.push(parent);
    return newStore;
}
function ungroup(store, group) {
    let childIds = group.items;
    return Object.assign(Object.assign({}, store), { arrows: store.arrows.map(a => Arrays.includes(childIds, a.id) ? Object.assign(Object.assign({}, a), { parentGroup: undefined }) : a), items: store.items.map(i => Arrays.includes(childIds, i.id) ? Object.assign(Object.assign({}, i), { parentGroup: undefined }) : i), groups: store.groups.filter(g => g.id !== group.id).map(g => Arrays.includes(childIds, g.id) ? Object.assign(Object.assign({}, g), { parentGroup: undefined }) : g) });
}
